var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import hbjs from "harfbuzzjs/hbjs";
/**
 * Static wrapper around the HarfBuzz hb.wasm module
 */
export class HarfBuzz {
    /**
     * Returns the loaded module, or throws if the module is not yet initialized yet.
     *
     * As long as this is called after the 'HarfBuzz.init' promise has resolved then this will never throw.
     *
     * A renderer should initialize this very early so rendering systems can just assume the module is present to avoid
     * polluting synchronous code with async just to lazily load the module.
     */
    static get module() {
        if (this.state.loaded !== undefined) {
            return this.state.loaded;
        }
        else {
            throw new Error("Tried to get harfbuzz module when it is not yet initialized");
        }
    }
    /**
     * Takes a path string produced by HarfBuzzFont.glyphToFont and decodes the string into an array of objects for more
     * easily consuming the path.
     *
     * This is takend directly from the implementation of HarfBuzzFont.glyphToJson.
     *
     * @param path
     */
    static pathStringToObject(path) {
        return path
            .replace(/([MLQCZ])/g, "|$1 ")
            .split("|")
            .filter((x) => x.length)
            .map((x) => {
            const row = x.split(/[ ,]/g);
            return {
                type: row[0],
                values: row
                    .slice(1)
                    .filter((v) => v.length)
                    .map((v) => +v),
            };
        });
    }
    /**
     * Internal function for initializing the module
     * @private
     */
    static init(url) {
        return __awaiter(this, void 0, void 0, function* () {
            // If the loader is already loaded then just return it immediately
            if (this.state.loaded !== undefined) {
                return this.state.loaded;
            }
            else {
                // If it isn't loaded we start a request to load and initialize the module
                if (this.state.inFlight === undefined) {
                    const initializer = () => __awaiter(this, void 0, void 0, function* () {
                        // Load the module from the URL
                        const result = yield fetch(url !== null && url !== void 0 ? url : "hb.wasm");
                        const buffer = yield result.arrayBuffer();
                        const module = yield WebAssembly.instantiate(buffer);
                        // Grow the module's memory to a useful size
                        // @ts-ignore
                        module.instance.exports.memory.grow(400);
                        // Initialize the module
                        return hbjs(module.instance);
                    });
                    this.state.inFlight = initializer();
                }
                // Now we know the request is definitely in flight so we wait for it to resolve
                // Write out the loaded loader and return it
                this.state.loaded = yield this.state.inFlight;
                return this.state.loaded;
            }
        });
    }
}
HarfBuzz.state = {};
